import React from "react"
import PropTypes from "prop-types"
import {Entity, EntityInfo} from "../../shared-components/constants/entities"
import TableContainer from "../../shared-components/components/Table/tableContainer"
import {getEntity} from "../../store/selectors/entities/entitiesSelectors"
import * as tableSelectors from "../../store/selectors/temporaries/tableSelectors"
import PaginationContainer from "../../shared-components/components/Pagination/paginationContainer"
import {getActivePage, getMaxPage} from "../../store/selectors/temporaries/paginationSelectors"
import {Loader} from "semantic-ui-react"
import Button from "../../shared-components/components/Button/button"
import {Segment} from "semantic-ui-react"

import "./detailsRefundTable.scss"

const DetailsRefundTable = ({
    changePage,
    clearRefundDetails,
    detailsRefundId,
    detailsRefundNumber,
    getRefundNumber,
    isFetchingRetrieve,
    sortColumnFunction,
    totalResults,
}) => (
    <Segment className="details-refund">
        <div className="details-refund-paragraph">
            Détails de la remise {detailsRefundNumber ? detailsRefundNumber : getRefundNumber(detailsRefundId)}
        </div>
        <div className="details-refund-table">
            <TableContainer
                columns={[
                    {type: "TEXT", name: "Numéro de chèque", accessor: "id"},
                    {type: "TEXT", name: "Nom bénéficiaire", accessor: "beneficiaryName"},
                    {type: "TEXT", name: "Valeur faciale (€)", accessor: "value"},
                    {type: "TEXT", name: "Millésime", accessor: "millesime"},
                ]}
                entityHelperFunction={(state, id) => getEntity(state, EntityInfo[Entity.CHECKBOOKS].name, id)}
                name="detailsRefundTable"
                sortColumnFunction={sortColumnFunction}
                sortable
                {...tableSelectors}
            />
        </div>

        <div className="details-refund-pagination">
            <Button className="details-refund-pagination-close-button" onClick={clearRefundDetails} type="danger">
                Fermer
            </Button>
            <div className="details-refund-pagination-content">
                <div className="details-refund-pagination-content-info">
                    {isFetchingRetrieve && <Loader active inline />}
                    {!isFetchingRetrieve && totalResults !== 0 && <span>{totalResults} résultat(s). </span>}
                    {!isFetchingRetrieve && totalResults === 0 && <span>Pas de résultats. </span>}
                </div>
                <PaginationContainer
                    componentName="detailsRefundTablePagination"
                    getActivePage={getActivePage}
                    getMaxPage={getMaxPage}
                    onPaginationClick={changePage}
                />
            </div>
        </div>
    </Segment>
)

DetailsRefundTable.propTypes = {
    changePage: PropTypes.func.isRequired,
    clearRefundDetails: PropTypes.func.isRequired,
    detailsRefundId: PropTypes.number.isRequired,
    getRefundNumber: PropTypes.func.isRequired,
    isFetchingRetrieve: PropTypes.bool.isRequired,
    sortColumnFunction: PropTypes.func.isRequired,
    totalResults: PropTypes.number.isRequired,
}

export default DetailsRefundTable
